<!-- <section class="content-header">
    <h1>
        {{title}}
    </h1>
</section> -->
<section class="content">


    <section>
        <!-- <section class="content-header">
      <h1>
          {{title}}

      </h1>
      <ol class="breadcrumb">
          <li><a href="Dashboard"><i class="fa fa-home"></i> Home</a></li>
          <li style="color:red;">Options</li>
      </ol>
  </section> -->


        <div class="row">
            <!-- /.box -->
            <div class="box  box-primary">
                
                    <PageHeader class="pageHeaderButtonPosition" [title]="title" [showAddNew]="true" [addurl]="AddUrl" #pageheader
                        [(searchText)]="searchText" [isSearchOpen]="ShowSearch"
                        (searchShowChange)="onSearchShowChange($event)" [showMainListing]="false" [showCheckInInventory]="true"
                        [showImportParts]="true"  [showImportEquipment]="true"
                        (importInventoryPartsClick)="ImportInventoryParts()" (importInventoryEquipmentClick)="ImportInventoryEquipment()"></PageHeader>
                
                <div id="divSearch row" *ngIf="ShowSearch">


                    <div class="col-md-12 box ibox box-primary boxSearch">
                        <div class="box-header">
                            <h3 class="box-title">Search Records</h3>
                        </div>

                        <div class="box-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label class="col-sm-6 control-label">Category:</label>
                                            <div class="col-sm-6">
                                                <select class="form-control" (change)="fillManufacturers()"
                                                        name="categoryId" [(ngModel)]="page.Category">
                                                        <option value="{{item.text}}"
                                                            *ngFor="let item of CategoryList">{{item.text}}</option>
                                                    </select>
                                            </div>


                                        </div>
                                        <div class="clearfix"></div>
                                    </div>
                                    <div class="col-sm-6">
                                            <div class="form-group">
                                                <label class="col-sm-6 control-label">Type:</label>
                                                <div class="col-sm-6">
                                                    <select class="form-control" [(ngModel)]="page.SelectedType">
                                                        <option value="{{item.value}}" *ngFor="let item of TypeList">
                                                            {{item.text}}
                                                        </option>
                                                    </select>
                                                </div>


                                            </div>
                                            <div class="clearfix"></div>
                                        </div>

                                </div>
                            </div>
                        </div>
                        <div class="box-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label class="col-sm-6 control-label">Manufacturer:</label>
                                            <div class="col-sm-6">                                              
                                                     <select class="form-control" [(ngModel)]="page.manufacturerId"
                                                        name="manufacturerId" (change)="fillAndSetModelList()">
                                                        <option value="">Select</option>
                                                        <option value="{{item.value}}"
                                                            *ngFor="let item of ManufacturerList">{{item.text}}</option>
                                                    </select>
                                            </div>


                                        </div>
                                        <div class="clearfix"></div>
                                    </div>
                                    <div class="col-sm-6">
                                            <div class="form-group">
                                                <label class="col-sm-6 control-label">Model:</label>
                                                <div class="col-sm-6">
                                                     <select class="form-control" [(ngModel)]="page.modelId"
                                                        name="modelId">
                                                        <option value="">Select</option>
                                                        <option value="{{item.value}}" *ngFor="let item of ModelList">
                                                            {{item.text}}</option>
                                                    </select>
                                                </div>


                                            </div>
                                            <div class="clearfix"></div>
                                        </div>

                                </div>
                            </div>
                        </div>

                        <div class="box-body">
                            <div class="row">
                                <div class="col-sm-12">
                                   <div class="col-sm-6">
                                        <div class="form-group">
                                            <label class="col-sm-6 control-label">Product/Part ID:</label>
                                            <div class="col-sm-6">
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    [(ngModel)]="page.ProductId"
                                                >
                                            </div>


                                        </div>
                                        <div class="clearfix"></div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label class="col-sm-6 control-label">Product/Part Name:</label>
                                            <div class="col-sm-6">
                                                <input type="text" class="form-control" [(ngModel)]="page.ProductName">
                                            </div>
                                        </div>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="box-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="col-sm-6">
                                        <div>
                                            <label class="col-sm-6 control-label">Description:</label>
                                            <div class="col-sm-6">
                                                <input type="text" class="form-control" [(ngModel)]="page.ProductDesc">


                                            </div>
                                        </div>
                                    </div>

                                    <!-- <div class="col-sm-6">
                                        <div class="form-group">
                                            <label class="col-sm-6 control-label">Division:</label>
                                            <div class="col-sm-6">
                                                <select class="form-control" [(ngModel)]="page.Division">
                                                    <option value="{{item.value}}" *ngFor="let item of DivisionList">
                                                        {{item.text}}
                                                    </option>
                                                </select>
                                            </div>


                                        </div>
                                        <div class="clearfix"></div>
                                    </div> -->

                                </div>
                            </div>
                        </div>

                        <div class="box-body">
                            <div class="row">
                                <div class="col-sm-12">

                                    <div class="col-sm-6">
                                        <div>
                                            <label class="col-sm-6 control-label">Vendor:</label>
                                            <div class="col-sm-6">
                                                <select class="form-control" [(ngModel)]="page.Vendor">
                                                    <option value="">Select</option>
                                                    <option value="{{item.contactId}}" *ngFor="let item of VendorList">
                                                        {{item.givenName}}
                                                    </option>
                                                </select>


                                          </div>
                                      </div>
                                  </div>
                                  <div class="col-sm-6">
                                      <div>
                                          <label class="col-sm-6 control-label">Present Equipment Status:</label>
                                          <div class="col-sm-6">
                                              <select class="form-control" [(ngModel)]="page.Status">
                                                  <option value="{{item.value}}" *ngFor="let item of StatusList">
                                                      {{item.text}}
                                                  </option>
                                              </select>


                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                        <div class="box-body">
                            <div class="row">
                                <div class="col-sm-12"></div>
                            </div>
                        </div>


                        <!-- <div class="box-body row">
                            <div class="col-sm-12">
                                <div class="col text-center">
                                    <button class="btn btn-primary" id="btnSearchDetail"
                                        (click)="executeInventorySearch()">
                                        <span>
                                            <i class="fa fa-search"></i>
                                        </span>
                                        <b>Search</b>
                                    </button>
                                </div>
                            </div>
                        </div> -->
                        <searchbutton (searchClick)="executeInventorySearch()" (cancelClick)="hideSearch()"></searchbutton>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="box-body" id="dvboxbody">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="col-sm-6 pull-right zIndex1000">
                                <div class="col text-right">
                                    <ngb-pagination pageSize="25" [boundaryLinks]="true"
                                        [collectionSize]="page.totalElements" [(page)]="page.pageNumber"
                                        (pageChange)="setPage()" [maxSize]="10" [directionLinks]="true">
                                    </ngb-pagination>
                                </div>
                            </div>
                            <div class="col-sm-3 pull-right noBorderSearchPadding zIndex1000">

                                    <select class="form-control noBorderSearch" [(ngModel)]="page.Division"
                                        (change)="DialysisUnitDropDownChanged()">
                                        <!-- <option value="">Select</option> -->
                                        <option value="{{item.value}}" *ngFor="let item of DivisionList">
                                            {{item.text}}
                                        </option>
                                    </select>

                            </div>
                            <div class="col-sm-3">
                                <div class="col text-left noofrecords">
                                    <span>
                                        <b>
                                            {{page.totalElements}}  {{page.totalElements > 1 ? 'Records' : 'Record'}} Found.
                                        </b>
                                    </span>
                                    <span *ngIf="blnDirtySearch">
                                        <a style="cursor:pointer" (click)="executeInventorySearchClear()">
                                            (
                                            <span>
                                                <i class="fa fa-trash-o"></i>
                                            </span>
                                            <b>Clear Search</b>
                                        </a>
                                        )
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive-custom">
                        <table id="OptionList" class="table table-bordered table-striped dataTable no-footer"
                            role="grid">
                            <thead>


                                <tr>
                                    <th *ngFor="let tableHeader of tableHeaders"
                                        [ngClass]="setSortIndicator(tableHeader.Label)"
                                        [style.width.%]="tableHeader.Width" (click)="changeSorting(tableHeader.Label)">
                                        {{tableHeader.Label}}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>


                                <tr *ngFor="let InventoryDetail of rows;let index=index;"
                                    (click)="_onRowClick(InventoryDetail.equipementid)" class="pointer">
                                    <td matTooltip="{{InventoryDetail.equipmentdesc}}" matTooltipShowDelay="500">
                                        {{(page.pageSize*(page.currentPageNumber-1)) + (index + 1)}}
                                    </td>
                                    <td matTooltip="{{InventoryDetail.equipmentdesc}}">
                                        {{InventoryDetail.equipmentcode}}
                                    </td>
                                    <td matTooltip="{{InventoryDetail.equipmentdesc}}">
                                        {{ (InventoryDetail.equipmentname.length>50)? (InventoryDetail.equipmentname | slice:0:50)+'..':(InventoryDetail.equipmentname) }}
                                    </td>
                                     <td matTooltip="{{InventoryDetail.equipmentdesc}}">
                                        {{InventoryDetail.equipmenttype}}
                                    </td>
                                    <td  matTooltip="{{InventoryDetail.equipmentdesc}}">{{InventoryDetail.categoryName}}</td>
                                    <td  matTooltip="{{InventoryDetail.equipmentdesc}}">{{InventoryDetail.model}}</td>
                                    <td  matTooltip="{{InventoryDetail.equipmentdesc}}">{{InventoryDetail.vendorName}}</td>
                                    <td  matTooltip="{{InventoryDetail.equipmentdesc}}">{{InventoryDetail.presentstaus}}</td>
                                    <td  matTooltip="{{InventoryDetail.equipmentdesc}}">
                                        {{(InventoryDetail.itemcost |
                                            currency:"CAD":"symbol-narrow")}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>


                    <div class="row">
                        <div class="col-sm-12">
                            <div class="col-sm-9 pull-right zIndex1000">
                                <div class="col text-right">
                                    <ngb-pagination pageSize="25" [boundaryLinks]="true"
                                        [collectionSize]="page.totalElements" [(page)]="page.pageNumber"
                                        (pageChange)="setPage()" [maxSize]="10" [directionLinks]="true">
                                    </ngb-pagination>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="col text-left noofrecords">
                                    <span>
                                        <b>
                                            {{page.totalElements}}  {{page.totalElements > 1 ? 'Records' : 'Record'}} Found.
                                        </b>
                                    </span>
                                    <span *ngIf="blnDirtySearch">
                                        <a style="cursor:pointer" (click)="executeInventorySearchClear()">
                                            (
                                            <span>
                                                <i class="fa fa-trash-o"></i>
                                            </span>
                                            <b>Clear Search</b>
                                        </a>
                                        )
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="ph-modal-backdrop" *ngIf="showImportModal">
            <div class="ph-modal">
                <div class="ph-modal-header">
                    <h4 class="m-0">Import Parts</h4>
                    <button type="button" class="close" (click)="closeImportInventoryParts()">&times;</button>
                </div>
                <div class="ph-modal-body">
                    <p class="mb-2">
                         Select an Excel file using the template (Category, Manufacturer, Assign To, Item Name, Item ID, Description, Vendor).
                        <a href="javascript:void(0)" (click)="onDownloadPartsTemplate()">Download Template</a>
                    </p>
                     <div class="mt-2">
                        <input type="file" accept=".xlsx,.xls" (change)="onExcelFileChange($event)" />
                     </div>

                <div *ngIf="validationDone" class="mt-3">
                      <!-- Other invalid rows (non-email), if any -->
                    <div *ngIf="invalidRows.length && (invalidRows.length !== invalidEmailRows.length)">
                    <h5 class="text-danger">Other Invalid Rows ({{ invalidRows.length - invalidEmailRows.length }})</h5>
                    <div class="table-responsive">
                        <table class="table table-sm table-bordered">
                        <thead>
                            <tr>
                            <th>Row #</th>
                            <th>Errors</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of invalidRows">
                            <ng-container *ngIf="!(invalidEmailRows | json).includes((r | json))">
                                <td>{{ r.rowNumber }}</td>
                                <td>{{ (r.errors || []).join('; ') }}</td>
                            </ng-container>
                            </tr>
                        </tbody>
                        </table>
                    </div>
                    </div>

                    <!-- Duplicates -->
                    <div *ngIf="duplicateInExcel.length || duplicateInDatabase.length" class="mt-3">
                        <div class="text-red mb-2" *ngIf="validationDone && validRows.length == 0">Fix the above rows in Excel and re-upload.</div>
                    <h5 class="text-warning">Duplicates Found</h5>

                    <div *ngIf="duplicateInExcel.length" class="mb-2">
                        <strong>In Excel ({{ duplicateInExcel.length }}):</strong>
                        <ul class="mb-0">
                        <li *ngFor="let r of duplicateInExcel">Row {{ r.rowNumber }} — {{ r.barCode }}</li>
                        </ul>
                    </div>

                    <div *ngIf="duplicateInDatabase.length">
                        <strong>Already in Database ({{ duplicateInDatabase.length }}): </strong>
                        <ul class="mb-0">
                        <li *ngFor="let r of duplicateInDatabase">{{ r.barCode }}</li>
                        </ul>
                    </div>
          
                    <small class="text-muted d-block mt-1" *ngIf="validRows.length > 0">You can still import unique rows only.</small>
                    </div>

                    <!-- Summary -->
                    <div class="mt-3">
                    <span class="badge bg-success">Valid: {{ validRows.length }}</span>
                    <span class="badge bg-danger ms-2">Invalid: {{ invalidRows.length }}</span>
                    <span class="badge bg-warning ms-2">Dup(Excel): {{ duplicateInExcel.length }}</span>
                    <span class="badge bg-warning ms-2">Dup(DB): {{ duplicateInDatabase.length }}</span>
                    </div>
                </div>

                </div>
                
                <div class="ph-modal-footer">
                    <button class="btn btn-primary"
                        *ngIf="validationDone && validRows.length > 0 && invalidRows.length == 0"
                        [disabled]="isCommitting"
                        (click)="confirmImportExcel()">
                    <span *ngIf="!isCommitting && (duplicateInDatabase.length > 0 || duplicateInExcel.length > 0)">Import (Unique Only)</span>
                    <span *ngIf="!isCommitting && (duplicateInDatabase.length == 0 && duplicateInExcel.length == 0)">Import</span>
                    <span *ngIf="isCommitting">Importing...</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="ph-modal-backdrop" *ngIf="showImportEquipment">
            <div class="ph-modal">
                <div class="ph-modal-header">
                    <h4 class="m-0">Import Equipment</h4>
                    <button type="button" class="close" (click)="closeImportInventoryEquipment()">&times;</button>
                </div>
                <div class="ph-modal-body">
                    <p class="mb-2">
                        Select an Excel file using the template (Category, Manufacturer, Model, Item Group, Item ID, Serial Number, Division, Description, Vendor).
                        <a href="javascript:void(0)" (click)="onDownloadEquipmentTemplate()">Download Template</a>
                    </p>
                     <input class="mt-2" type="file" accept=".xlsx,.xls" (change)="onExcelFileEquipmentChange($event)" />
                
                     <div *ngIf="validationDone" class="mt-3">
                      <!-- Other invalid rows (non-email), if any -->
                    <div *ngIf="invalidRows.length && (invalidRows.length !== invalidEmailRows.length)">
                    <h5 class="text-danger">Other Invalid Rows ({{ invalidRows.length - invalidEmailRows.length }})</h5>
                    <div class="table-responsive">
                        <table class="table table-sm table-bordered">
                        <thead>
                            <tr>
                            <th>Row #</th>
                            <th>Errors</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of invalidRows">
                            <ng-container *ngIf="!(invalidEmailRows | json).includes((r | json))">
                                <td>{{ r.rowNumber }}</td>
                                <td>{{ (r.errors || []).join('; ') }}</td>
                            </ng-container>
                            </tr>
                        </tbody>
                        </table>
                    </div>
                    </div>

                    <!-- Duplicates -->
                    <div *ngIf="duplicateInExcel.length || duplicateInDatabase.length" class="mt-3">
                        <div class="text-red mb-2" *ngIf="validationDone && validRows.length == 0">Fix the above rows in Excel and re-upload.</div>
                    <h5 class="text-warning">Duplicates Found</h5>

                    <div *ngIf="duplicateInExcel.length" class="mb-2">
                        <strong>In Excel ({{ duplicateInExcel.length }}):</strong>
                        <ul class="mb-0">
                        <li *ngFor="let r of duplicateInExcel">Row {{ r.rowNumber }} — {{ r.serialNumber }}</li>
                        </ul>
                    </div>

                    <div *ngIf="duplicateInDatabase.length">
                        <strong>Already in Database ({{ duplicateInDatabase.length }}): </strong>
                        <ul class="mb-0">
                        <li *ngFor="let r of duplicateInDatabase">{{ r.serialNumber }}</li>
                        </ul>
                    </div>
          
                    <small class="text-muted d-block mt-1" *ngIf="validRows.length > 0">You can still import unique rows only.</small>
                    </div>

                    <!-- Summary -->
                    <div class="mt-3">
                    <span class="badge bg-success">Valid: {{ validRows.length }}</span>
                    <span class="badge bg-danger ms-2">Invalid: {{ invalidRows.length }}</span>
                    <span class="badge bg-warning ms-2">Dup(Excel): {{ duplicateInExcel.length }}</span>
                    <span class="badge bg-warning ms-2">Dup(DB): {{ duplicateInDatabase.length }}</span>
                    </div>
                </div>
                    </div>
                 <div class="ph-modal-footer">
                    <button class="btn btn-primary"
                        *ngIf="validationDone && validRows.length > 0 && invalidRows.length == 0"
                        [disabled]="isCommitting"
                        (click)="confirmImportEquipmentExcel()">
                    <span *ngIf="!isCommitting && (duplicateInDatabase.length > 0 || duplicateInExcel.length > 0)">Import (Unique Only)</span>
                    <span *ngIf="!isCommitting && (duplicateInDatabase.length == 0 && duplicateInExcel.length == 0)">Import</span>
                    <span *ngIf="isCommitting">Importing...</span>
                    </button>
                </div>
            </div>
        </div>

    </section>
</section>
